import React, { useState } from "react";
import { Form, Input, InputNumber, Button, Select, Modal, DatePicker, Row, Col } from "antd";
import { isAuthenticated } from "../../Auth/auth";
import { Error, Success } from "../../Messages/Messages";
import axios from "axios";
import SelectComp from "../../Select/Select";
import MainButtonComp from "../../Buttons/MainButtonComp";
import { generalErrorAlert } from "../../GeneralErrorAlert";
import InventoryUsage from "../../Inventory/InventoryUsage";
import { useTranslation } from "react-i18next";

const { TextArea } = Input;

export const CreateNewMilestone = ({ projectId, employeesArray, updateParent, inventoryList }) => {
  const { t } = useTranslation("dashboard");
  let serviceProviderId = isAuthenticated()?.employer?._id
    ? isAuthenticated()?.employer?._id
    : isAuthenticated()?.serviceProviderId;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [team, setTeam] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setTeam([]);
    form.resetFields();
  };

  const handleChange = val => {
    setTeam(val);
  };

  const onFinish = async values => {
    try {
      if (team?.length === 0) return Error(t("Please add a team"));
      setLoading(true);

      await axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/milestones/add`,
          { ...values, team, projectId, serviceProvider: serviceProviderId },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          setLoading(false);
          if (res.status === 200 || res.status === 304) {
            Success(res.data.successMessage);
            handleCancel();
            setTeam([]);
            form.resetFields();
            updateParent();
          } else {
            Error(res.data.errorMessage);
          }
        })
        .catch(err => {
          setLoading(false);
          generalErrorAlert(err);
        });
    } catch (error) {
      generalErrorAlert(error);
    }
  };

  return (
    <div>
      <MainButtonComp text="Add Milestone" addBtn onClick={showModal} />
      <Modal
        title={t("Add Milestone")}
        open={isModalOpen}
        onCancel={handleCancel}
        width={720}
        destroyOnClose
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={() => form.submit()}>
            {t("Add Milestone")}
          </Button>
        ]}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={[16, 0]}>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Name")}
                name="name"
                rules={[{ required: true, message: t("enter", { field: t("Name") }) }]}
              >
                <Input size="large" placeholder={t("e.g. Phase 1 - Foundation")} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label={t("Payment type")} name={"paymentType"}>
                <Select size="large" placeholder={t("Select payment type")}>
                  <Select.Option value="hourly">{t("Hourly")}</Select.Option>
                  <Select.Option value="totalAmount">{t("Total Amount")}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 0]}>
            <Col xs={24} md={8}>
              <Form.Item label={t("Amount")} name="price">
                <InputNumber min={1} style={{ width: "100%" }} size="large" placeholder="0.00" />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item label={t("Currency")} name="currency">
                <Select size="large" placeholder={t("Select currency")}>
                  <Select.Option value="$">{t("USD")}</Select.Option>
                  <Select.Option value="€">{t("Euro")}</Select.Option>
                  <Select.Option value="Custom">{t("Custom")}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item label={t("Start Date")} name="startDate">
                <DatePicker
                  style={{ width: "100%" }}
                  format={"DD/MMM/YYYY"}
                  size="large"
                  placeholder={t("Select start date")}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 0]}>
            <Col xs={24}>
              <Form.Item label={t("Description")} name="description">
                <TextArea rows={4} placeholder={t("Enter milestone details...")} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 0]}>
            <Col xs={24}>
              <Form.Item label={t("Team")} required>
                <div className="input-block">
                  <SelectComp
                    type="tags"
                    handleChange={val => handleChange(val)}
                    options={employeesArray}
                    placeholder={t("Select team members")}
                  />
                </div>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 0]}>
            <Col xs={24}>
              <div>
                <h3 className="mb-3">{t("Inventory")}</h3>
                <InventoryUsage form={form} inventoryList={inventoryList} />
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
